const e=async e=>{let{data:t}=await e.get(`/auth/mfa`);return t};export{e as getMfaStatus};
//# sourceMappingURL=get-mfa-status.mjs.map